// Reuse the Google tag initialized in public/index.html. Keep the historical
// event name and parameter so existing Analytics reports continue to work.
export function trackSearch(searchTerm) {
  if (
    typeof window === "undefined" ||
    typeof window.gtag !== "function" ||
    typeof searchTerm !== "string" ||
    !searchTerm.trim()
  ) {
    return;
  }

  try {
    window.gtag("event", "search", { search_term: searchTerm });
  } catch {
    // Analytics failures must not prevent visitors from seeing search results.
  }
}
